import { render } from "./detectorReport.vue?vue&type=template&id=2eb85b54&scoped=true"
import script from "./detectorReport.vue?vue&type=script&lang=js"
export * from "./detectorReport.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=2eb85b54&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb85b54"]])

export default __exports__